import "core-js/stable";
import "regenerator-runtime/runtime";
// import "@babel/polyfill" 今までの指定

// my polyfill
import "./lib/polyfill"

import "objectFitPolyfill";


import Hamburger from "./modules/Hamburger";
import globalNav from "./modules/globalNav";
import Accordion from "./modules/accordion";


window.addEventListener('DOMContentLoaded', (event) => {
    const hamburger = new Hamburger()
    hamburger.toggle()
    const accordion = new Accordion()
    accordion.toggle()

    globalNav()
});


// スムーズスクロール
const header = $('.l-header');

$(window).on('load', function () {
  $('a[href^="#"]:not(a.popup-tubelet,a.popup-yubiami,a.popup-funloom,a.popup-howto,a.popup-huzzle-1,a.popup-huzzle-2,a.popup-katunou-1,a.popup-katunou-2,a.popup-game-1,a.popup-game-2,a.popup-crystal-1,a.popup-crystal-2,a.popup-games,a.popup-logicalnewton)').click(function () {
    const header_height = header.height();
    $('html,body').animate({
      scrollTop: $($(this).attr('href')).offset().top - header_height + 1
    }, 500);
    return false;
  })
});
